import { Button } from '@shared/components/ui/button';
import { useTranslation } from 'react-i18next';

interface ErrorStateProps {
  error: Error | unknown;
  onRetry?: () => void;
}

export const ErrorState = ({ error, onRetry }: ErrorStateProps) => {
  const { t } = useTranslation('manifestsModule');

  return (
    <div className="px-6 pt-4">
      <div className="flex flex-col items-center justify-center py-12">
        <p className="text-lg text-destructive mb-4">{t('error.title', 'Error al cargar los manifiestos')}</p>
        <p className="text-sm text-muted-foreground mb-4">
          {error instanceof Error ? error.message : t('error.unknown', 'Error desconocido')}
        </p>
        {onRetry && (
          <Button onClick={onRetry} variant="outline">
            {t('error.retry', 'Reintentar')}
          </Button>
        )}
      </div>
    </div>
  );
};
